<!-- Translated: skip -->
<template>
  <Modal @close="closeModal" :wide="false" normal-width="90vw" width="960px">
    <div v-if="SITE_CONFIG.accomodations.show_site" @click.stop="stopper">
      <div :class="'map-background map-background--' + params.locationId + ' type--' + params.type" v-html="svg" v-show="params.locationId">
      </div>
      <div class="center" v-show="params.locationId">
        <a target="_blank" :href="params.map_link" v-if="params.map_link" class="button white small border map-bt">
          <icon name="map" :scale="2" /> Se områdeskarta
          <icon name="download" class="dowload-icon" :scale="1.5" />
        </a>
      </div>
      <div v-show="params.locationId && params.type === 'interactive'" class="center" style="margin-top: 15px;">
        <button @click="setLocation(2006, true)" v-if="params.locationId === 2006" class="small">
          Sök på alla områden på Branäsberget
        </button>
        <button @click="setLocation(2007, true)" v-if="params.locationId === 2007" class="small">
          Sök på alla områden i Branäsdalen
        </button>
        <button @click="setLocation(2020, true)" v-if="params.locationId === 2020" class="small">
          Sök på alla områden i Mattesdalen
        </button>
      </div>
      <div v-show="!params.locationId">
        <div class="col">
          <h2><icon name="berget" :scale="1.5" /> Branäsberget</h2>
          <p>I Branäsbergets stugor och lägenheter får du en fantastisk utsikt över dalen och närhet till skidåkning, pulkabackar och längdspår. Uppe på berget finns skiduthyrning, shop, livsmedelsbutik och restauranger.</p>
          <button class="small" @click="openMap(2006)">Karta över Branäsberget</button>
        </div>
        <div class="col">
          <h2><icon name="byn" :scale="1.5" /> Branäsdalen</h2>
          <p>I Branäsdalen finns både lägenheter och större fjällstugor, med nära till allt du behöver. I Branäsdalen har du nära till skiduthyrning, restaurang, shop och en livsmedelsbutik.</p>
          <button class="small" @click="openMap(2007)">Karta över Branäsdalen</button>
        </div>
        <div class="col">
          <h2><icon name="mattesdalen" :scale="1.5" /> Mattesdalen</h2>
          <p>I Mattesdalen finns både lägenheter och större, moderna fjällstugor. Bor du här har du nära till både 4-stolslift och 6-stolslift som snabbt tar dig upp till toppen och resten av skidområdet.</p>
          <button class="small" @click="openMap(2020)">Mattesdalen</button>
        </div>
      </div>
    </div>
    <div v-if="!SITE_CONFIG.accomodations.show_site" @click.stop="stopper">
      <div :class="'map-background map-background--' + SITE_CONFIG.site + ' type--' + params.type" v-html="svg"></div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import API from '@/classes/API';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
      svg: '',
      styleNode: '',
    };
  },
  watch: {
    myStyleProp(val) {
      this.styleNode.textContent = val;
      return this.styleNode.textContent;
    },
  },
  mounted() {
    if (this.params.locationId || !this.SITE_CONFIG.accomodations.show_site) {
      this.loadMap();
    }
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'changeMapLocation',
      'openModal',
      'setFilterLocationId',
      'awaitFilter',
    ]),
    stopper() {
    },
    setLocation(id, isArea) {
      let newId = id;
      if (isArea) {
        newId = `area-${newId}`;
      }
      this.setFilterLocationId(newId);
      this.$emit('change', newId);
      this.awaitFilter();
      this.closeModal();
    },
    loadMap() {
      const $this = this;

      const overlay = this.SITE_CONFIG.accomodations.show_site
        ? this.params.locationId : this.SITE_CONFIG.site;

      API.get(`accommodation-map-branas-${overlay}.svg`).then((result) => {
        $this.svg = result;

        $this.$nextTick(() => {
          const selector = '.map-background svg > g > g';
          const gs = document.querySelectorAll(selector);
          const areaId = $this.params.areaId;

          console.log(gs);

          /* eslint-disable */
          [].forEach.call(gs, (g) => {
            g.classList.remove('selected');

            const parts = g.id.split('-');
            if (parts[1] && areaId && parts[1].toString() === areaId.toString()) {
              g.classList.add('selected');
            }

            if ($this.params.type === 'interactive') {
              g.addEventListener('click', (e) => {
                $this.setLocation(parseInt(parts[1]));

                const gs = document.querySelectorAll(selector);
                const areaId = $this.params.areaId;

                [].forEach.call(gs, (g) => {
                  g.classList.remove('selected');
                });
                g.classList.add('selected');
                // $this.closeModal();
              });
            }
          });
        });
      });
    },
    openMap(id) {
      this.params.locationId = id;
      this.loadMap();
    },
  },
  filters: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.col
  float left
  width 33%
  padding-right 50px
  +max-mobile()
    width 100%
    padding-right 0
    padding-bottom 40px
  h2
    .icon
      margin-right 15px
    uppercase()
    font-size: 22px;
  p
    font-size: 13px;
    font-weight: 300;
    line-height 1.15em
    margin-top 15px
    margin-bottom 25px
</style>

<style lang="stylus">
selected()
  fill:#005580 !important;
  // opacity:0.6183 !important;
  // stroke:#325E00 !important;
  // stroke-width:2px !important;

.branas .map-background
  width:100% !important
  // width 80vw
  max-width 960px !important
  position:relative !important
  //height 100px
  background-repeat:no-repeat !important
  background-size:100% !important
  overflow hidden !important
  svg
    position absolute !important
    top 0 !important
    left 0 !important
    width 100% !important

  svg > g > rect
    display none !important

  // Base style
  svg > g > g > path
    // opacity:0.604 !important;
    // stroke: #FB9C00 !important;
    // stroke-width:2px !important;
    // fill:#373737 !important;
    transition:all 0.3s ease !important

  // Text style
  svg > g > g > text
    // fill:white !important;
    font-family:Barlow !important
    // font-size:10px !important;
    // font-weight: bold !important;

  // Selected
  svg > g > g.selected > rect,
  &.type--interactive svg > g > g:hover > rect
    selected()

  // Map backgrounds
  &.map-background--2006
    background-image: url(https://static.booking.branasgruppen.se/static/img/map-231114/berget-2006-2.jpg) !important
    height 1px !important
    padding-top:42% !important
    svg
      top 0% !important
  &.map-background--2007
    background-image: url(https://static.booking.branasgruppen.se/static/img/map-231114/byn-2007.jpg) !important
    height 1px !important
    padding-top:112% !important
    svg
      top 0% !important
  &.map-background--2020
    background-image: url(https://static.booking.branasgruppen.se/static/img/map-231114/mattesdalen-2020.jpg) !important
    height 1px !important
    padding-top:57% !important
    svg
      top 0% !important
  // &.map-background--kungsberget
  //   background-image: url(https://static.booking.branasgruppen.se/static/img/map-231114/background-branas-kungsberget.jpg)
  //   height 1px
  //   padding-top:56%;
  //   svg
  //     top 0%
.map-background.type--interactive
  svg
    g
      cursor: pointer;

.browser-ie .map-background.map-background--kungsberget
  svg
    top 0%
.browser-ie .map-background.map-background--2006
  svg
    top 0%
.browser-ie .map-background.map-background--2007
  svg
    top 0%
.browser-ie .map-background.map-background--2020
  svg
    top 0%

.type--undefined.map-background svg > switch > g > g > path
  fill: transparent !important;
  stroke: transparent !important;
.type--undefined.map-background svg > switch > g > g.selected > path
  fill: #417505 !important;
  stroke: #325e00 !important;

.map-bt
  margin-bottom: 20px
  text-align: left
  background-color: #f9fcfd!important;
  color: #dark-blue!important;
  padding-right: 20px;
  padding-top: 10px!important
  padding-bottom: 7px!important
  margin-top: 10px
  .icon
    position: relative;
    top: -2px
    margin-right: 5px
  .dowload-icon
    margin-left: 10px

</style>



// WEBPACK FOOTER //
// MapModalbranas.vue?4da23d86